import React from "react";

const RadioButton = ({
    field: { name, value, onChange, onBlur },
    form: { setErrors },
    id,
    label,
    ...props
}) => {
    return (
        <div>
            <input
                name={name}
                id={id}
                type="radio"
                value={id}
                checked={id === value}
                onChange={onChange}
                onClick={() =>
                    setErrors({
                        qualifications: null,
                        hasAdditionalQualifications: null,
                    })
                }
                onBlur={onBlur}
                {...props}
            />
            <label htmlFor={id}>{label}</label>
        </div>
    );
};

export default RadioButton;
